import styled from "styled-components";
import { DivContentPage } from "../../components/common/DivContentPage";

const DivMain = styled(DivContentPage)`
  .btnToggleWhitelist {
    height: 100%;
    padding: 8px 16px;
    border-radius: 10px;
    white-space: nowrap;
    flex-shrink: 0;
  }

  /* ---- USER PICKER ---- */
  .divUserPicker {
    width: 100%;
    border: 1.5px solid #e8e8ee;
    border-radius: 14px;
    padding: 16px;
    margin-bottom: 20px;
    background: #fafafa;

    .divPickerTabs {
      display: flex;
      flex-direction: row;
      gap: 6px;
      margin-bottom: 12px;

      .btnPickerTab {
        padding: 6px 18px;
        border-radius: 20px;
        border: 1.5px solid #dcdce8;
        background: #ffffff;
        font-family: "Roboto", Helvetica, sans-serif;
        font-size: 13px;
        font-weight: 500;
        color: #6b6b80;
        cursor: pointer;
        transition: all 0.15s;
        &:hover {
          border-color: #13131d;
          color: #13131d;
        }
        &.active {
          background: #13131d;
          border-color: #13131d;
          color: #ffffff;
        }
      }
    }

    .divPickerSearchRow {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;
      margin-bottom: 12px;

      .inputPickerSearch {
        flex: 1;
        height: 40px;
        padding: 0 14px;
        border: 1.5px solid #dcdce8;
        border-radius: 10px;
        font-family: "Roboto", Helvetica, sans-serif;
        font-size: 14px;
        color: #13131d;
        background: #ffffff;
        outline: none;
        &:focus {
          border-color: #13131d;
        }
        &::placeholder {
          color: #a0a0b0;
        }
      }

      .selectPickerAddType {
        height: 40px;
        padding: 0 12px;
        border: 1.5px solid #dcdce8;
        border-radius: 10px;
        font-family: "Roboto", Helvetica, sans-serif;
        font-size: 13px;
        font-weight: 400;
        color: #13131d;
        background-color: #ffffff;
        cursor: pointer;
        outline: none;
        white-space: nowrap;
        &:focus {
          border-color: #13131d;
        }
      }

      .btnPickerSearch {
        height: 40px;
        width: 60px;
        padding: 0 18px;
        border-radius: 10px;
        white-space: nowrap;
        flex-shrink: 0;
      }
    }

    .divPickerLoading {
      width: 100%;
      display: flex;
      justify-content: center;
      padding: 30px 0;
    }

    .divPickerEmpty {
      width: 100%;
      display: flex;
      justify-content: center;
      padding: 28px 20px;

      .txtPickerEmpty {
        font-family: "Roboto", Helvetica, sans-serif;
        font-size: 14px;
        font-weight: 400;
        color: #a0a0b0;
        text-align: center;
        max-width: 380px;
        line-height: 1.6;
      }
    }

    .pickerTable {
      width: 100%;
    }

    .btnAddUser {
      height: 34px;
      padding: 0 12px;
      border-radius: 8px;
      white-space: nowrap;
      font-size: 13px;
    }
  }

  /* ---- WHITELIST SECTION ---- */
  .divWhitelistSection {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .txtSectionTitle {
      font-family: "Roboto", Helvetica, sans-serif;
      font-size: 14px;
      font-weight: 600;
      color: #13131d;
    }
  }

  .whitelistTable {
    width: 100%;
    flex: 1;
  }

  .divEmptyWhitelist {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px 20px;

    .txtEmptyWhitelist {
      font-family: "Roboto", Helvetica, sans-serif;
      font-size: 14px;
      font-weight: 400;
      color: #a0a0b0;
      text-align: center;
      line-height: 1.6;
    }
  }
`;

const whitelistStyles = { DivMain };
export default whitelistStyles;
